const rankingItems = [
  { rank: 1, title: '某知名导演私生活混乱内幕全记录', views: '128.6万', trend: 'up', hot: true },
  { rank: 2, title: '顶流明星深夜密会神秘女子完整视频', views: '115.3万', trend: 'up', hot: true },
  { rank: 3, title: '上市公司CEO内幕交易关键证据曝光', views: '87.9万', trend: 'up', hot: false },
  { rank: 4, title: '知名女团成员私下接客实锤视频流出', views: '96.3万', trend: 'down', hot: true },
  { rank: 5, title: '某综艺节目导演组内斗录音曝光', views: '72.1万', trend: 'up', hot: false },
  { rank: 6, title: '头部带货主播虚假宣传全套证据发布', views: '68.4万', trend: 'up', hot: false },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            <i className="ri-trophy-fill"></i>
            热度排行
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            本周热榜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            黑料视频在线观看热度排行，看看大家都在看什么
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 border border-secondary-200/60 rounded-xl overflow-hidden">
            {rankingItems.map((item, i) => (
              <div
                key={i}
                className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-background-100 transition-colors ${
                  i < rankingItems.length - 1 ? 'border-b border-secondary-100' : ''
                }`}
              >
                <div className="w-8 h-8 flex items-center justify-center shrink-0">
                  {item.rank <= 3 ? (
                    <span className={`text-lg font-heading font-bold ${
                      item.rank === 1 ? 'text-primary-500' :
                      item.rank === 2 ? 'text-accent-500' :
                      'text-secondary-500'
                    }`}>
                      {item.rank}
                    </span>
                  ) : (
                    <span className="text-base font-semibold text-foreground-400">{item.rank}</span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm md:text-base font-medium text-foreground-800 line-clamp-1">
                      {item.title}
                    </span>
                    {item.hot && (
                      <span className="flex items-center gap-0.5 px-1.5 py-0.5 rounded bg-primary-100 text-primary-600 text-xs font-medium shrink-0">
                        <i className="ri-fire-fill text-xs"></i>
                        热
                      </span>
                    )}
                  </div>
                </div>

                <div className="flex items-center gap-3 shrink-0">
                  <span className="text-xs text-foreground-400">{item.views}</span>
                  <span className={`text-xs ${
                    item.trend === 'up' ? 'text-primary-500' : 'text-foreground-400'
                  }`}>
                    <i className={item.trend === 'up' ? 'ri-arrow-up-s-fill' : 'ri-arrow-down-s-fill'}></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}